import { useEffect, useState } from 'react';
export var useCurrentAccordionIndex = function (ref) {
    var _a = useState(1), currentIndex = _a[0], setCurrentIndex = _a[1];
    useEffect(function () {
        var node = ref.current;
        var index = 1;
        while ((node = node.previousElementSibling)) {
            index++;
        }
        setCurrentIndex(index);
    }, []);
    return currentIndex;
};
